import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiTarget, FiTrendingUp, FiCheckCircle } from 'react-icons/fi';
import './About.css';

const About: React.FC = () => {
  const { t } = useTranslation();

  const highlights = [
    'highlight1',
    'highlight2',
    'highlight3',
    'highlight4'
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        {/* Video ve Yazılar Yan Yana - Video Solda Dikey */}
        <div className="about-main-layout">
          {/* Sol Kısım - Dikey Video */}
          <motion.div 
            className="about-video-column"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="about-video-wrapper">
              <video 
                autoPlay 
                loop 
                muted 
                playsInline
                className="about-video-vertical"
              >
                <source src="/about.mp4" type="video/mp4" />
              </video>
            </div>
          </motion.div>

          {/* Sağ Kısım - Tüm Yazılar */}
          <motion.div 
            className="about-content-column"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="about-intro">{t('about.intro')}</p>
            <p className="about-paragraph">{t('about.paragraph1')}</p>
            <p className="about-paragraph">{t('about.paragraph2')}</p>
            
            <div className="about-highlights">
              {highlights.map((key, index) => (
                <div key={index} className="highlight-item">
                  <FiCheckCircle className="highlight-icon" />
                  <span>{t(`about.${key}`)}</span>
                </div>
              ))}
            </div>

            {/* Vizyon & Misyon */}
            <div className="about-vm-section">
              <div className="vm-card">
                <div className="vm-icon"><FiTarget /></div>
                <h3>{t('about.vision')}</h3>
                <p>{t('about.visionText')}</p>
              </div>
              <div className="vm-card">
                <div className="vm-icon"><FiTrendingUp /></div>
                <h3>{t('about.mission')}</h3>
                <p>{t('about.missionText')}</p>
              </div>
            </div>

            {/* Kapanış ve Slogan */}
            <div className="about-closing">
              <p>{t('about.closing')}</p>
              <p className="about-slogan">{t('about.slogan')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
